import { render, staticRenderFns } from "./carfigForm.vue?vue&type=template&id=ff2360f0&scoped=true"
import script from "./carfigForm.vue?vue&type=script&lang=js"
export * from "./carfigForm.vue?vue&type=script&lang=js"
import style0 from "./carfigForm.vue?vue&type=style&index=0&id=ff2360f0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff2360f0",
  null
  
)

export default component.exports